/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../_chunks/dep-fd3498b6.js';
import { _ as _typeof } from '../_chunks/dep-e9b62d1f.js';
import { _ as _asyncToGenerator, r as regenerator } from '../_chunks/dep-e0370ebe.js';
import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import React, { forwardRef, useState, useRef, useMemo, useEffect, useImperativeHandle } from 'react';
import { i as isObject_1 } from '../_chunks/dep-88cd50bf.js';
import { i as isString_1 } from '../_chunks/dep-6c5254c6.js';
import { g as get_1 } from '../_chunks/dep-337b4140.js';
import { m as merge_1 } from '../_chunks/dep-d71ee5f3.js';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import { CheckCircleFilledIcon, CloseCircleFilledIcon, ErrorCircleFilledIcon } from 'tdesign-icons-react';
import { calcFieldValue } from './utils/index.js';
import useConfig from '../hooks/useConfig.js';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { HOOK_MARK } from './hooks/useForm.js';
import { parseMessage, validate } from './formModel.js';
import { useFormContext, useFormListContext } from './FormContext.js';
import useFormItemStyle from './hooks/useFormItemStyle.js';
import { formItemDefaultProps } from './defaultProps.js';
import { getDefaultInitialData, ctrlKeyMap } from './useInitialData.js';
import { ValidateStatus } from './const.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-ca64038e.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../config-provider/ConfigContext.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../_chunks/dep-e51b1270.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../_chunks/dep-64a9d67c.js';
import '../_chunks/dep-23d0a0bb.js';
import '../_chunks/dep-0e15088f.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import 'classnames';
import '../_util/parseTNode.js';
import '../tree/Tree.js';
import 'react-transition-group';
import '../_util/usePersistFn.js';
import '../tree/useTreeConfig.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../tree/useControllable.js';
import '../hooks/useControlled.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_util/noop.js';
import '../tree/TreeItem.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../_util/dom.js';
import 'raf';
import '../_util/easing.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../checkbox/index.js';
import '../_chunks/dep-e3db8410.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../common/Check.js';
import '../_chunks/dep-7dad86aa.js';
import '../_util/helper.js';
import '../_chunks/dep-2ffb6f37.js';
import '../_chunks/dep-08c1f545.js';
import '../checkbox/defaultProps.js';
import '../checkbox/style/css.js';
import '../checkbox/type.js';
import '../tree/useDraggable.js';
import '../_chunks/dep-b0a01ce1.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../tree/TreeDraggableContext.js';
import '../_util/createHookContext.js';
import '../_util/composeRefs.js';
import '../tree/useStore.js';
import '../_chunks/dep-0bc19feb.js';
import '../_chunks/dep-09050977.js';
import '../_chunks/dep-c8399d32.js';
import '../_util/useUpdateEffect.js';
import '../_util/useLayoutEffect.js';
import '../_common/js/tree/tree-store.js';
import '../_chunks/dep-1cec561b.js';
import '../_chunks/dep-7004b0d9.js';
import '../_chunks/dep-e73d1b75.js';
import 'mitt';
import '../_common/js/tree/tree-node.js';
import '../_chunks/dep-a827ffec.js';
import '../_common/js/tree/tree-node-model.js';
import '../_chunks/dep-4f1e1217.js';
import '../_chunks/dep-29cb89ad.js';
import '../_chunks/dep-7b67cdbf.js';
import '../upload/upload.js';
import '../upload/themes/NormalFile.js';
import '../link/index.js';
import '../link/Link.js';
import '../link/style/css.js';
import '../_common/js/upload/utils.js';
import '../upload/themes/DraggerFile.js';
import '../hooks/useCommonClassName.js';
import '../upload/hooks/useDrag.js';
import '../image-viewer/index.js';
import '../image-viewer/ImageViewer.js';
import '../_chunks/dep-10388ab5.js';
import '../tooltip/index.js';
import '../tooltip/Tooltip.js';
import '../popup/index.js';
import '../popup/Popup.js';
import 'react-popper';
import '../hooks/usePrevious.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../popup/style/css.js';
import '../popup/type.js';
import '../tooltip/defaultProps.js';
import '../tooltip/TooltipLite.js';
import '../_util/useSwitch.js';
import '../_common/js/utils/getPosition.js';
import '../tooltip/style/css.js';
import '../tooltip/type.js';
import '../image-viewer/utils.js';
import '../dialog/index.js';
import '../dialog/Dialog.js';
import '../_util/useSetState.js';
import '../dialog/defaultProps.js';
import '../dialog/DialogCard.js';
import '../button/index.js';
import '../button/Button.js';
import '../button/defaultProps.js';
import '../button/style/css.js';
import '../button/type.js';
import '../dialog/hooks/useDialogEsc.js';
import '../dialog/hooks/useLockStyle.js';
import '../_common/js/utils/getScrollbarWidth.js';
import '../dialog/hooks/useDialogPosition.js';
import '../dialog/hooks/useDialogDrag.js';
import '../dialog/utils.js';
import '../dialog/plugin.js';
import '../dialog/style/css.js';
import '../dialog/type.js';
import '../image-viewer/hooks/useMirror.js';
import '../image-viewer/hooks/usePosition.js';
import '../image-viewer/hooks/useIndex.js';
import '../image-viewer/hooks/useRotate.js';
import '../image-viewer/hooks/useScale.js';
import '../image-viewer/hooks/useIconMap.js';
import '../image-viewer/defaultProps.js';
import '../image-viewer/hooks/useImageScale.js';
import '../image-viewer/hooks/useList.js';
import '../image-viewer/hooks/useViewerScale.js';
import '../image-viewer/style/css.js';
import '../upload/themes/ImageCard.js';
import '../upload/themes/MultipleFlowList.js';
import '../upload/hooks/useUpload.js';
import '../_common/js/upload/main.js';
import '../_common/js/upload/xhr.js';
import '../upload/defaultProps.js';
import '../upload/themes/CustomFile.js';
import '../tag/CheckTag.js';
import '../tag/defaultProps.js';
import '../tag-input/TagInput.js';
import '../_util/useDragSorter.js';
import '../input/index.js';
import '../input/Input.js';
import '../input/InputGroup.js';
import '../input/defaultProps.js';
import '../input/useLengthLimit.js';
import '../input/style/css.js';
import '../input/type.js';
import '../tag-input/useTagScroll.js';
import '../tag-input/useTagList.js';
import '../tag/index.js';
import '../tag/Tag.js';
import '../tag/style/css.js';
import '../tag/type.js';
import '../tag-input/useHover.js';
import '../tag-input/defaultProps.js';
import '../range-input/RangeInput.js';
import '../range-input/defaultProps.js';
import '../transfer/Transfer.js';
import '../transfer/TransferList.js';
import '../transfer/utils.js';
import '../pagination/index.js';
import '../pagination/Pagination.js';
import '../select/index.js';
import '../select/base/Select.js';
import '../select/util/helper.js';
import '../select/base/OptionGroup.js';
import '../select/defaultProps.js';
import '../select/base/Option.js';
import '../common/FakeArrow.js';
import '../select-input/index.js';
import '../select-input/SelectInput.js';
import '../select-input/useSingle.js';
import '../select-input/useMultiple.js';
import '../tag-input/index.js';
import '../tag-input/style/css.js';
import '../tag-input/type.js';
import '../select-input/useOverlayInnerStyle.js';
import '../select-input/defaultProps.js';
import '../select-input/style/css.js';
import '../select-input/type.js';
import '../select/base/PopupContent.js';
import '../select/hooks/usePanelVirtualScroll.js';
import '../hooks/useVirtualScroll.js';
import '../hooks/useResizeObserver.js';
import '../select/hooks/useOptions.js';
import '../select/style/css.js';
import '../select/type.js';
import '../input-number/index.js';
import '../input-number/InputNumber.js';
import '../input-number/useInputNumber.js';
import '../_util/useCommonClassName.js';
import '../_common/js/input-number/number.js';
import '../_common/js/input-number/large-number.js';
import '../input-number/defaultProps.js';
import '../input-number/style/css.js';
import '../input-number/type.js';
import '../input-adornment/index.js';
import '../input-adornment/InputAdornment.js';
import '../input-adornment/style/css.js';
import '../input-adornment/type.js';
import '../pagination/hooks/useBoundaryJumper.js';
import '../pagination/hooks/usePrevNextJumper.js';
import '../pagination/hooks/usePageNumber.js';
import '../pagination/hooks/useTotal.js';
import '../pagination/validators.js';
import '../pagination/defaultProps.js';
import '../pagination/PaginationMini.js';
import '../pagination/style/css.js';
import '../pagination/type.js';
import '../transfer/defaultProps.js';
import '../date-picker/DateRangePicker.js';
import '../range-input/index.js';
import '../range-input/RangeInputPopup.js';
import '../range-input/style/css.js';
import '../range-input/type.js';
import '../date-picker/panel/RangePanel.js';
import '../date-picker/panel/PanelContent.js';
import '../date-picker/base/Header.js';
import '../date-picker/base/Table.js';
import '../date-picker/base/Cell.js';
import '../_common/js/date-picker/utils.js';
import '../_chunks/dep-fdce1f4f.js';
import '../_common/js/date-picker/format.js';
import '../time-picker/index.js';
import '../time-picker/TimePicker.js';
import '../time-picker/TimeRangePicker.js';
import '../time-picker/panel/TimePickerPanel.js';
import '../time-picker/panel/SinglePanel.js';
import '../time-picker/hooks/useTimePickerTextConfig.js';
import '../_common/js/time-picker/const.js';
import '../_common/js/time-picker/utils.js';
import '../hooks/useDebounce.js';
import '../hooks/usePropsRef.js';
import '../time-picker/defaultProps.js';
import '../time-picker/style/css.js';
import '../time-picker/type.js';
import '../date-picker/panel/ExtraContent.js';
import '../date-picker/base/Footer.js';
import '../date-picker/hooks/useTableData.js';
import '../date-picker/hooks/useDisableDate.js';
import '../date-picker/hooks/useRange.js';
import '../date-picker/hooks/useRangeValue.js';
import '../date-picker/defaultProps.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FormItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix,
    globalFormConfig = _useConfig.form;
  var _useGlobalIcon = useGlobalIcon({
      CheckCircleFilledIcon: CheckCircleFilledIcon,
      CloseCircleFilledIcon: CloseCircleFilledIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon
    }),
    CheckCircleFilledIcon$1 = _useGlobalIcon.CheckCircleFilledIcon,
    CloseCircleFilledIcon$1 = _useGlobalIcon.CloseCircleFilledIcon,
    ErrorCircleFilledIcon$1 = _useGlobalIcon.ErrorCircleFilledIcon;
  var _useFormContext = useFormContext(),
    form = _useFormContext.form,
    colon = _useFormContext.colon,
    layout = _useFormContext.layout,
    initialDataFromContext = _useFormContext.initialData,
    requiredMarkFromContext = _useFormContext.requiredMark,
    labelAlignFromContext = _useFormContext.labelAlign,
    labelWidthFromContext = _useFormContext.labelWidth,
    showErrorMessageFromContext = _useFormContext.showErrorMessage,
    disabledFromContext = _useFormContext.disabled,
    resetTypeFromContext = _useFormContext.resetType,
    rulesFromContext = _useFormContext.rules,
    statusIconFromContext = _useFormContext.statusIcon,
    errorMessage = _useFormContext.errorMessage,
    formMapRef = _useFormContext.formMapRef,
    onFormItemValueChange = _useFormContext.onFormItemValueChange;
  var _useFormListContext = useFormListContext(),
    formListName = _useFormListContext.name,
    formListRules = _useFormListContext.rules,
    formListMapRef = _useFormListContext.formListMapRef;
  var children = props.children,
    style = props.style,
    label = props.label,
    name = props.name,
    status = props.status,
    tips = props.tips,
    help = props.help,
    initialData = props.initialData,
    className = props.className,
    shouldUpdate = props.shouldUpdate,
    successBorder = props.successBorder,
    _props$statusIcon = props.statusIcon,
    statusIcon = _props$statusIcon === void 0 ? statusIconFromContext : _props$statusIcon,
    _props$rules = props.rules,
    innerRules = _props$rules === void 0 ? getInnerRules(name, rulesFromContext, formListName, formListRules) : _props$rules,
    _props$labelWidth = props.labelWidth,
    labelWidth = _props$labelWidth === void 0 ? labelWidthFromContext : _props$labelWidth,
    _props$labelAlign = props.labelAlign,
    labelAlign = _props$labelAlign === void 0 ? labelAlignFromContext : _props$labelAlign,
    _props$requiredMark = props.requiredMark,
    requiredMark = _props$requiredMark === void 0 ? requiredMarkFromContext : _props$requiredMark;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    forceUpdate = _useState2[1];
  var _useState3 = useState(void 0),
    _useState4 = _slicedToArray(_useState3, 2),
    freeShowErrorMessage = _useState4[0],
    setFreeShowErrorMessage = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    errorList = _useState6[0],
    setErrorList = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    successList = _useState8[0],
    setSuccessList = _useState8[1];
  var _useState9 = useState("validating"),
    _useState10 = _slicedToArray(_useState9, 2),
    verifyStatus = _useState10[0],
    setVerifyStatus = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    resetValidating = _useState12[0],
    setResetValidating = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    needResetField = _useState14[0],
    setNeedResetField = _useState14[1];
  var _useState15 = useState(getDefaultInitialData({
      name: name,
      formListName: formListName,
      children: children,
      initialData: initialData,
      initialDataFromContext: initialDataFromContext
    })),
    _useState16 = _slicedToArray(_useState15, 2),
    formValue = _useState16[0],
    setFormValue = _useState16[1];
  var formItemRef = useRef();
  var innerFormItemsRef = useRef([]);
  var shouldEmitChangeRef = useRef(false);
  var isUpdatedRef = useRef(false);
  var shouldValidate = useRef(false);
  var valueRef = useRef(formValue);
  var errorListMapRef = useRef( /* @__PURE__ */new Map());
  var snakeName = [].concat(formListName, name).filter(function (item) {
    return item !== void 0;
  }).join("_");
  var errorMessages = useMemo(function () {
    return errorMessage !== null && errorMessage !== void 0 ? errorMessage : globalFormConfig.errorMessage;
  }, [errorMessage, globalFormConfig]);
  var showErrorMessage = useMemo(function () {
    if (typeof freeShowErrorMessage === "boolean") return freeShowErrorMessage;
    if (typeof props.showErrorMessage === "boolean") return props.showErrorMessage;
    return showErrorMessageFromContext;
  }, [freeShowErrorMessage, props.showErrorMessage, showErrorMessageFromContext]);
  var _useFormItemStyle = useFormItemStyle({
      className: className,
      help: help,
      tips: tips,
      snakeName: snakeName,
      status: status,
      successBorder: successBorder,
      errorList: errorList,
      successList: successList,
      layout: layout,
      verifyStatus: verifyStatus,
      colon: colon,
      label: label,
      labelWidth: labelWidth,
      labelAlign: labelAlign,
      requiredMark: requiredMark,
      showErrorMessage: showErrorMessage,
      innerRules: innerRules
    }),
    formItemClass = _useFormItemStyle.formItemClass,
    formItemLabelClass = _useFormItemStyle.formItemLabelClass,
    contentClass = _useFormItemStyle.contentClass,
    labelStyle = _useFormItemStyle.labelStyle,
    contentStyle = _useFormItemStyle.contentStyle,
    helpNode = _useFormItemStyle.helpNode,
    extraNode = _useFormItemStyle.extraNode;
  var updateFormValue = function updateFormValue(newVal) {
    var _form$getInternalHook, _form$getFieldsValue;
    var validate2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var shouldEmitChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _ref = (form === null || form === void 0 ? void 0 : (_form$getInternalHook = form.getInternalHooks) === null || _form$getInternalHook === void 0 ? void 0 : _form$getInternalHook.call(form, HOOK_MARK)) || {},
      setPrevStore = _ref.setPrevStore;
    setPrevStore === null || setPrevStore === void 0 ? void 0 : setPrevStore(form === null || form === void 0 ? void 0 : (_form$getFieldsValue = form.getFieldsValue) === null || _form$getFieldsValue === void 0 ? void 0 : _form$getFieldsValue.call(form, true));
    shouldEmitChangeRef.current = shouldEmitChange;
    isUpdatedRef.current = true;
    shouldValidate.current = validate2;
    valueRef.current = newVal;
    setFormValue(newVal);
  };
  function getInnerRules(name2, formRules, formListName2, formListRules2) {
    if (Array.isArray(name2)) {
      return get_1(formRules === null || formRules === void 0 ? void 0 : formRules[formListName2], name2) || get_1(formListRules2, name2) || [];
    }
    return (formRules === null || formRules === void 0 ? void 0 : formRules[name2]) || formListRules2 || [];
  }
  var renderSuffixIcon = function renderSuffixIcon() {
    if (statusIcon === false) return null;
    var resultIcon = function resultIcon(iconSlot) {
      return /* @__PURE__ */React.createElement("span", {
        className: "".concat(classPrefix, "-form__status")
      }, iconSlot);
    };
    var getDefaultIcon = function getDefaultIcon() {
      var iconMap = {
        success: /* @__PURE__ */React.createElement(CheckCircleFilledIcon$1, {
          size: "25px"
        }),
        error: /* @__PURE__ */React.createElement(CloseCircleFilledIcon$1, {
          size: "25px"
        }),
        warning: /* @__PURE__ */React.createElement(ErrorCircleFilledIcon$1, {
          size: "25px"
        })
      };
      if (verifyStatus === ValidateStatus.SUCCESS) {
        return resultIcon(iconMap[verifyStatus]);
      }
      if (errorList && errorList[0]) {
        var type = errorList[0].type || "error";
        return resultIcon(iconMap[type]);
      }
      return null;
    };
    if ( /*#__PURE__*/React.isValidElement(statusIcon)) {
      return resultIcon( /*#__PURE__*/React.cloneElement(statusIcon, _objectSpread({
        style: {
          color: "unset"
        }
      }, statusIcon.props)));
    }
    if (statusIcon === true) {
      return getDefaultIcon();
    }
    return null;
  };
  function analysisValidateResult(_x) {
    return _analysisValidateResult.apply(this, arguments);
  }
  function _analysisValidateResult() {
    _analysisValidateResult = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(trigger) {
      var _result$rules;
      var result;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            result = {
              successList: [],
              errorList: [],
              rules: [],
              resultList: [],
              allowSetValue: false
            };
            result.rules = trigger === "all" ? innerRules : innerRules.filter(function (item) {
              return (item.trigger || "change") === trigger;
            });
            if ((_result$rules = result.rules) !== null && _result$rules !== void 0 && _result$rules.length) {
              _context.next = 5;
              break;
            }
            setResetValidating(false);
            return _context.abrupt("return", result);
          case 5:
            result.allowSetValue = true;
            _context.next = 8;
            return validate(formValue, result.rules);
          case 8:
            result.resultList = _context.sent;
            result.errorList = result.resultList.filter(function (item) {
              return item.result !== true;
            }).map(function (item) {
              Object.keys(item).forEach(function (key) {
                if (!item.message && errorMessages[key]) {
                  item.message = parseMessage(errorMessages[key], {
                    validate: item[key],
                    name: isString_1(label) ? label : String(name)
                  });
                }
              });
              return item;
            });
            result.successList = result.resultList.filter(function (item) {
              return item.result === true && item.message && item.type === "success";
            });
            return _context.abrupt("return", result);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _analysisValidateResult.apply(this, arguments);
  }
  function validate$1() {
    return _validate.apply(this, arguments);
  }
  function _validate() {
    _validate = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      var trigger,
        showErrorMessage2,
        _yield$analysisValida,
        innerSuccessList,
        innerErrorList,
        validateRules,
        resultList,
        allowSetValue,
        cacheErrorList,
        status2,
        _innerErrorList$,
        _cacheErrorList$,
        _args2 = arguments;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            trigger = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : "all";
            showErrorMessage2 = _args2.length > 1 ? _args2[1] : undefined;
            if (!innerFormItemsRef.current.length) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return", innerFormItemsRef.current.map(function (innerFormItem) {
              return innerFormItem === null || innerFormItem === void 0 ? void 0 : innerFormItem.validate(trigger, showErrorMessage2);
            }));
          case 4:
            setResetValidating(true);
            setFreeShowErrorMessage(showErrorMessage2);
            _context2.next = 8;
            return analysisValidateResult(trigger);
          case 8:
            _yield$analysisValida = _context2.sent;
            innerSuccessList = _yield$analysisValida.successList;
            innerErrorList = _yield$analysisValida.errorList;
            validateRules = _yield$analysisValida.rules;
            resultList = _yield$analysisValida.resultList;
            allowSetValue = _yield$analysisValida.allowSetValue;
            if (innerErrorList.length && trigger !== "all") {
              errorListMapRef.current.set(trigger, innerErrorList);
            } else {
              errorListMapRef.current["delete"](trigger);
            }
            if (!innerErrorList.length && trigger === "all") {
              errorListMapRef.current.clear();
            }
            cacheErrorList = _toConsumableArray(errorListMapRef.current.values()).flat();
            if (allowSetValue) {
              setSuccessList(innerSuccessList);
              setErrorList(cacheErrorList.length ? cacheErrorList : innerErrorList);
            }
            if (validateRules.length) {
              status2 = ValidateStatus.SUCCESS;
              if (innerErrorList.length || cacheErrorList.length) {
                status2 = (innerErrorList === null || innerErrorList === void 0 ? void 0 : (_innerErrorList$ = innerErrorList[0]) === null || _innerErrorList$ === void 0 ? void 0 : _innerErrorList$.type) || (cacheErrorList === null || cacheErrorList === void 0 ? void 0 : (_cacheErrorList$ = cacheErrorList[0]) === null || _cacheErrorList$ === void 0 ? void 0 : _cacheErrorList$.type) || ValidateStatus.ERROR;
              }
              setVerifyStatus(status2);
            } else {
              setVerifyStatus(ValidateStatus.VALIDATING);
            }
            if (needResetField) {
              resetHandler();
            }
            setResetValidating(false);
            return _context2.abrupt("return", _defineProperty({}, snakeName, innerErrorList.length === 0 ? true : resultList));
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _validate.apply(this, arguments);
  }
  function validateOnly() {
    return _validateOnly.apply(this, arguments);
  }
  function _validateOnly() {
    _validateOnly = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var trigger,
        _yield$analysisValida2,
        innerErrorList,
        resultList,
        _args3 = arguments;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            trigger = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : "all";
            _context3.next = 3;
            return analysisValidateResult(trigger);
          case 3:
            _yield$analysisValida2 = _context3.sent;
            innerErrorList = _yield$analysisValida2.errorList;
            resultList = _yield$analysisValida2.resultList;
            return _context3.abrupt("return", _defineProperty({}, snakeName, innerErrorList.length === 0 ? true : resultList));
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _validateOnly.apply(this, arguments);
  }
  function handleItemBlur() {
    var filterRules = innerRules.filter(function (item) {
      return item.trigger === "blur";
    });
    filterRules.length && validate$1("blur");
  }
  function getResetValue(resetType) {
    if (resetType === "initial") {
      return getDefaultInitialData({
        name: name,
        formListName: formListName,
        children: children,
        initialData: initialData,
        initialDataFromContext: initialDataFromContext
      });
    }
    var emptyValue = "";
    if (Array.isArray(formValue)) {
      emptyValue = [];
    } else if (isObject_1(formValue)) {
      emptyValue = {};
    }
    return emptyValue;
  }
  function resetField(type) {
    if (typeof name === "undefined") return;
    var resetType = type || resetTypeFromContext;
    var resetValue = getResetValue(resetType);
    updateFormValue(resetValue, false);
    if (resetValidating) {
      setNeedResetField(true);
    } else {
      resetHandler();
    }
  }
  function resetHandler() {
    setNeedResetField(false);
    setErrorList([]);
    setSuccessList([]);
    setVerifyStatus(ValidateStatus.VALIDATING);
  }
  function setField(field) {
    var value = field.value,
      status2 = field.status,
      validateMessage = field.validateMessage;
    if (typeof status2 !== "undefined") {
      setErrorList(validateMessage ? [validateMessage] : []);
      setSuccessList(validateMessage ? [validateMessage] : []);
      setNeedResetField(false);
      setVerifyStatus(status2);
    }
    if (typeof value !== "undefined") {
      updateFormValue(value, typeof status2 === "undefined" ? true : false);
    }
  }
  function setValidateMessage(validateMessage) {
    var _validateMessage$;
    if (!validateMessage || !Array.isArray(validateMessage)) return;
    if (validateMessage.length === 0) {
      setErrorList([]);
      setVerifyStatus(ValidateStatus.SUCCESS);
      return;
    }
    setErrorList(validateMessage);
    var status2 = (validateMessage === null || validateMessage === void 0 ? void 0 : (_validateMessage$ = validateMessage[0]) === null || _validateMessage$ === void 0 ? void 0 : _validateMessage$.type) || ValidateStatus.ERROR;
    setVerifyStatus(status2);
  }
  useEffect(function () {
    var _form$getInternalHook2;
    if (!shouldUpdate || !form) return;
    var _ref2 = (form === null || form === void 0 ? void 0 : (_form$getInternalHook2 = form.getInternalHooks) === null || _form$getInternalHook2 === void 0 ? void 0 : _form$getInternalHook2.call(form, HOOK_MARK)) || {},
      getPrevStore = _ref2.getPrevStore,
      registerWatch = _ref2.registerWatch;
    var cancelRegister = registerWatch === null || registerWatch === void 0 ? void 0 : registerWatch(function () {
      var _form$getFieldsValue2;
      var currStore = (form === null || form === void 0 ? void 0 : (_form$getFieldsValue2 = form.getFieldsValue) === null || _form$getFieldsValue2 === void 0 ? void 0 : _form$getFieldsValue2.call(form, true)) || {};
      var updateFlag = shouldUpdate;
      if (isFunction_1(shouldUpdate)) updateFlag = shouldUpdate(getPrevStore === null || getPrevStore === void 0 ? void 0 : getPrevStore(), currStore);
      if (updateFlag) forceUpdate({});
    });
    return cancelRegister;
  }, [shouldUpdate, form]);
  useEffect(function () {
    if (typeof name === "undefined") return;
    if (formListName) {
      formListMapRef.current.set(name, formItemRef);
      return function () {
        formListMapRef.current["delete"](name);
      };
    }
    if (!formMapRef) return;
    formMapRef.current.set(name, formItemRef);
    return function () {
      formMapRef.current["delete"](name);
    };
  }, [name, formListName]);
  useEffect(function () {
    var _form$getInternalHook3, _form$getInternalHook4, _form$getInternalHook5;
    form === null || form === void 0 ? void 0 : (_form$getInternalHook3 = form.getInternalHooks) === null || _form$getInternalHook3 === void 0 ? void 0 : (_form$getInternalHook4 = _form$getInternalHook3.call(form, HOOK_MARK)) === null || _form$getInternalHook4 === void 0 ? void 0 : (_form$getInternalHook5 = _form$getInternalHook4.notifyWatch) === null || _form$getInternalHook5 === void 0 ? void 0 : _form$getInternalHook5.call(_form$getInternalHook4, name);
    if (!shouldValidate.current) return;
    if (typeof name !== "undefined") {
      if (formListName) {
        var formListValue = merge_1([], calcFieldValue(name, formValue));
        var fieldValue = calcFieldValue(formListName, formListValue);
        onFormItemValueChange === null || onFormItemValueChange === void 0 ? void 0 : onFormItemValueChange(_objectSpread({}, fieldValue));
      } else {
        var _fieldValue = calcFieldValue(name, formValue);
        onFormItemValueChange === null || onFormItemValueChange === void 0 ? void 0 : onFormItemValueChange(_objectSpread({}, _fieldValue));
      }
    }
    var filterRules = innerRules.filter(function (item) {
      return (item.trigger || "change") === "change";
    });
    filterRules.length && validate$1("change");
  }, [formValue]);
  var instance = {
    name: name,
    value: formValue,
    isUpdated: isUpdatedRef.current,
    getValue: function getValue() {
      return valueRef.current;
    },
    setValue: function setValue(newVal) {
      return updateFormValue(newVal);
    },
    setField: setField,
    validate: validate$1,
    validateOnly: validateOnly,
    resetField: resetField,
    setValidateMessage: setValidateMessage,
    resetValidate: resetHandler
  };
  useImperativeHandle(ref, function () {
    return instance;
  });
  useImperativeHandle(formItemRef, function () {
    return instance;
  });
  if (isFunction_1(children)) return children(form);
  return /* @__PURE__ */React.createElement("div", {
    className: formItemClass,
    style: style
  }, label && /* @__PURE__ */React.createElement("div", {
    className: formItemLabelClass,
    style: labelStyle
  }, /* @__PURE__ */React.createElement("label", {
    htmlFor: props === null || props === void 0 ? void 0 : props["for"]
  }, label)), /* @__PURE__ */React.createElement("div", {
    className: contentClass(),
    style: contentStyle
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(classPrefix, "-form__controls-content")
  }, React.Children.map(children, function (child, index) {
    if (!child) return null;
    var ctrlKey = "value";
    if ( /*#__PURE__*/React.isValidElement(child)) {
      var _objectSpread2;
      if (child.type === FormItem) {
        return /*#__PURE__*/React.cloneElement(child, {
          ref: function ref(el) {
            if (!el) return;
            innerFormItemsRef.current[index] = el;
          }
        });
      }
      if (_typeof(child.type) === "object") {
        ctrlKey = ctrlKeyMap.get(child.type) || "value";
      }
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({
        disabled: disabledFromContext
      }, child.props), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, ctrlKey, formValue), _defineProperty(_objectSpread2, "onChange", function onChange(value) {
        var _child$props$onChange, _child$props$onChange2;
        updateFormValue(value, true, true);
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        (_child$props$onChange = child.props.onChange) === null || _child$props$onChange === void 0 ? void 0 : (_child$props$onChange2 = _child$props$onChange.call) === null || _child$props$onChange2 === void 0 ? void 0 : _child$props$onChange2.call.apply(_child$props$onChange2, [_child$props$onChange, null, value].concat(args));
      }), _defineProperty(_objectSpread2, "onBlur", function onBlur(value) {
        var _child$props$onBlur, _child$props$onBlur$c;
        handleItemBlur();
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        (_child$props$onBlur = child.props.onBlur) === null || _child$props$onBlur === void 0 ? void 0 : (_child$props$onBlur$c = _child$props$onBlur.call) === null || _child$props$onBlur$c === void 0 ? void 0 : _child$props$onBlur$c.call.apply(_child$props$onBlur$c, [_child$props$onBlur, null, value].concat(args));
      }), _objectSpread2)));
    }
    return child;
  }), renderSuffixIcon()), helpNode, extraNode));
});
FormItem.displayName = "FormItem";
FormItem.defaultProps = formItemDefaultProps;

export { FormItem as default };
//# sourceMappingURL=FormItem.js.map
